import React from "react";
import {withRouter} from "react-router-dom"
import style from "./notFound.module.scss"
import Button from "../../Components/Button/button";
import Sadputer from "../../assets/icons/sadputer.svg"
import mobisha from "../../assets/icons/mobisha.svg"
import face from "../../assets/icons/face.svg"

const NotFound = (props) => {

    return (
        <div className={style.wrapper}>
            <div className={style.row}>
                <div className={style.box}>
                    <div className={style.left}>
                        <div className={style.imageWrapper}>
                            <img src={Sadputer} alt="" className={style.image}/>
                            <img src={face} className={style.face} alt=""/>
                        </div>
                    </div>
                    <div className={style.right}>
                        <div className={style.container}>

                            <div className={style.title}>خطای ۴۰۴</div>
                            <div className={style.bold}> به نظر میاد که گم شدیم :/</div>
                            <div className={style.text}> ببخشید که نتونستیم صفحه‌ای که دنبالش بودی رو پیدا کنیم. ولی
                                اشکالی نداره، کمکت می‌کنیم که راه رو پیدا کنی.
                            </div>
                            <div className={style.buttonWrapper}>
                                <a href="https://mobisha.ir/">
                                    <Button type="solid" label="بازگشت به خانه" onclick={() => {
                                    }}/>
                                </a>
                                <Button type="outline" label="نمایش داشبورد" onclick={() => {
                                    props.history.push("/")
                                }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={style.subtitle}>
                <img src={mobisha} alt="" className={style.image}/>
                <div className={style.text}>موبیشا | ربات قیمت‌گذاری دیجی‌کالا</div>
            </div>

        </div>
    )
}
export default withRouter(NotFound);



